class Component {
    calculate() {}
}

export default Component;
